// extracted by mini-css-extract-plugin
module.exports = {"list-details":"MyEquipmentSearchResults_list-details__8jb6I"};